import { useField } from "formik";
import { useCallback, useEffect, useRef, useState } from "react";
const useFormikInput = (name, {
  debounce,
  debounceDelay = 300,
  inputRef: inputRefParent,
  onBlur,
  onChange,
  isValueAllowed = () => true
} = {}) => {
  const [field, meta, helpers] = useField(name);
  const timeoutHandler = useRef(null);
  const [value, setValue] = useState(field.value);
  const inputRefInner = useRef(null);
  const inputRef = inputRefParent && typeof inputRefParent !== "function" ? inputRefParent : inputRefInner;
  useEffect(() => {
    if (debounce) {
      setValue(field.value);
    }
  }, [debounce, field.value]);
  const handleBlur = useCallback(
    (event) => {
      if (debounce) {
        const mappedValue = getValue(event);
        helpers.setValue(mappedValue);
      }
      helpers.setTouched(true);
      if (onBlur) {
        onBlur(event);
      }
    },
    [debounce, helpers, onBlur]
  );
  const handleChange = useCallback(
    (event) => {
      let newValue = getValue(event);
      const valueAllowed = isValueAllowed(newValue);
      if (debounce) {
        if (valueAllowed) {
          setValue(newValue);
        } else {
          newValue = value;
        }
        if (timeoutHandler.current) {
          clearTimeout(timeoutHandler.current);
        }
        timeoutHandler.current = setTimeout(() => {
          if (valueAllowed) {
            helpers.setValue(newValue);
          }
        }, debounceDelay);
      } else if (valueAllowed) {
        helpers.setValue(newValue);
      }
      if (onChange) {
        onChange(event);
      }
    },
    [debounce, debounceDelay, helpers, onChange, isValueAllowed, setValue, value]
  );
  return [
    {
      ...field,
      name,
      onBlur: handleBlur,
      onChange: handleChange,
      inputRef,
      validationMessage: meta.touched && !!meta.error ? meta.error : void 0,
      validationStatus: meta.touched && !!meta.error ? "error" : void 0,
      value: debounce ? value : field.value
    }
  ];
};
function getValue(event) {
  if (event.target.type === "number") {
    return event.target.valueAsNumber;
  }
  return event.target.value;
}
export {
  useFormikInput
};
//# sourceMappingURL=useFormikInput.js.map
